<template>
  <div class="data-dict-page">
    <el-row :gutter="24">
      <el-col :span="6">
        <el-card shadow="hover" class="dict-type-card">
          <div class="header">
            <span class="header-title">字典类型</span>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="openTypeDialog">新增类型</el-button>
          </div>
          <el-table :data="typeList" highlight-current-row @current-change="handleTypeSelect" :row-class-name="rowClassName" class="dict-type-table">
            <el-table-column prop="dictName" label="类型名称" align="center" />
            <el-table-column prop="dictType" label="类型编码" align="center" />
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button size="mini" icon="el-icon-edit" @click.stop="editType(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card shadow="hover" class="dict-data-card">
          <div class="header">
            <span class="header-title">字典数据</span>
            <el-button type="primary" size="mini" icon="el-icon-plus" :disabled="!currentType" @click="openDataDialog">新增数据</el-button>
          </div>
          <el-table :data="dataList" style="margin-top: 10px;" class="dict-data-table">
            <el-table-column prop="dictLabel" label="显示名称" align="center" />
            <el-table-column prop="dictValue" label="字典值" align="center" />
            <el-table-column prop="sort" label="排序" align="center" />
            <el-table-column prop="isActive" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isActive === 1 ? 'success' : 'info'">
                  {{ scope.row.isActive === 1 ? '有效' : '无效' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" />
            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="scope">
                <el-button size="mini" icon="el-icon-edit" @click="editData(scope.row)"></el-button>
                <el-button size="mini" icon="el-icon-delete" type="danger" @click="deleteData(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <!-- 类型弹窗 -->
    <el-dialog :title="typeDialogTitle" :visible.sync="typeDialogVisible" width="400px">
      <el-form :model="typeForm" :rules="typeRules" ref="typeFormRef" label-width="100px" class="dialog-form">
        <el-form-item label="类型名称" prop="dictName">
          <el-input v-model="typeForm.dictName" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="类型编码" prop="dictType">
          <el-input v-model="typeForm.dictType" :disabled="!!typeForm.id" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="typeForm.remark" maxlength="100" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="typeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitType">保存</el-button>
      </div>
    </el-dialog>

    <!-- 数据弹窗 -->
    <el-dialog :title="dataDialogTitle" :visible.sync="dataDialogVisible" width="400px">
      <el-form :model="dataForm" :rules="dataRules" ref="dataFormRef" label-width="100px" class="dialog-form">
        <el-form-item label="显示名称" prop="dictLabel">
          <el-input v-model="dataForm.dictLabel" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="字典值" prop="dictValue">
          <el-input v-model="dataForm.dictValue" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="dataForm.sort" :min="0" />
        </el-form-item>
        <el-form-item label="状态" prop="isActive">
          <el-switch v-model="dataForm.isActive" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" maxlength="100" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dataDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDictTypeList,
  addDictType,
  updateDictType,
  deleteDictType,
  getDictData,
  addDictData,
  updateDictData,
  deleteDictData
} from '@/api/dict'

export default {
  name: 'DataDict',
  data() {
    return {
      typeList: [],
      dataList: [],
      currentType: '',
      typeDialogVisible: false,
      typeDialogTitle: '',
      typeForm: {
        id: '',
        dictType: '',
        dictName: '',
        remark: ''
      },
      typeRules: {
        dictName: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
        dictType: [{ required: true, message: '请输入类型编码', trigger: 'blur' }]
      },
      dataDialogVisible: false,
      dataDialogTitle: '',
      dataForm: {
        id: '',
        dictType: '',
        dictLabel: '',
        dictValue: '',
        sort: 0,
        isActive: 1,
        remark: ''
      },
      dataRules: {
        dictLabel: [{ required: true, message: '请输入显示名称', trigger: 'blur' }],
        dictValue: [{ required: true, message: '请输入字典值', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.fetchTypeList()
  },
  methods: {
    async fetchTypeList() {
      try {
        const res = await getDictTypeList()
        this.typeList = res.data || []
        if (this.typeList.length && !this.currentType) {
          this.handleTypeSelect(this.typeList[0])
        }
      } catch (error) {
        console.error('获取字典类型列表失败:', error)
        this.$message.error('获取字典类型列表失败')
      }
    },
    handleTypeSelect(row) {
      this.currentType = row.dictType
      this.fetchDataList()
    },
    rowClassName({ row }) {
      return row.dictType === this.currentType ? 'current-row' : ''
    },
    async fetchDataList() {
      if (!this.currentType) return
      try {
        const res = await getDictData(this.currentType)
        this.dataList = res.data || []
      } catch (error) {
        console.error('获取字典数据列表失败:', error)
        this.$message.error('获取字典数据列表失败')
      }
    },
    openTypeDialog() {
      this.typeDialogTitle = '新增字典类型'
      this.typeDialogVisible = true
      this.typeForm = { id: '', dictType: '', dictName: '', remark: '' }
    },
    editType(row) {
      this.typeDialogTitle = '编辑字典类型'
      this.typeDialogVisible = true
      this.typeForm = { ...row }
    },
    async submitType() {
      try {
        await this.$refs.typeFormRef.validate()
        const isEdit = !!this.typeForm.id
        await (isEdit ? updateDictType(this.typeForm) : addDictType(this.typeForm))
        this.$message.success('保存成功')
        this.typeDialogVisible = false
        this.fetchTypeList()
      } catch (error) {
        if (error === false) return // 表单验证失败
        console.error('保存字典类型失败:', error)
        this.$message.error('保存字典类型失败')
      }
    },
    async deleteType(row) {
      try {
        await this.$confirm('确定删除该字典类型吗？', '提示', { type: 'warning' })
        await deleteDictType(row.id)
        this.$message.success('删除成功')
        this.fetchTypeList()
      } catch (error) {
        if (error === 'cancel') return
        console.error('删除字典类型失败:', error)
        this.$message.error('删除字典类型失败')
      }
    },
    openDataDialog() {
      this.dataDialogTitle = '新增字典数据'
      this.dataDialogVisible = true
      this.dataForm = { id: '', dictType: this.currentType, dictLabel: '', dictValue: '', sort: 0, isActive: 1, remark: '' }
    },
    editData(row) {
      this.dataDialogTitle = '编辑字典数据'
      this.dataDialogVisible = true
      this.dataForm = { ...row }
    },
    async submitData() {
      try {
        await this.$refs.dataFormRef.validate()
        const isEdit = !!this.dataForm.id
        await (isEdit ? updateDictData(this.dataForm) : addDictData(this.dataForm))
        this.$message.success('保存成功')
        this.dataDialogVisible = false
        this.fetchDataList()
      } catch (error) {
        if (error === false) return // 表单验证失败
        console.error('保存字典数据失败:', error)
        this.$message.error('保存字典数据失败')
      }
    },
    async deleteData(row) {
      try {
        await this.$confirm('确定删除该字典数据吗？', '提示', { type: 'warning' })
        await deleteDictData(row.id)
        this.$message.success('删除成功')
        this.fetchDataList()
      } catch (error) {
        if (error === 'cancel') return
        console.error('删除字典数据失败:', error)
        this.$message.error('删除字典数据失败')
      }
    }
  }
}
</script>

<style scoped>
.data-dict-page {
  padding: 32px 24px 24px 24px;
  background: #f4f6fa;
}
.dict-type-card, .dict-data-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.04);
  min-height: 500px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
}
.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.dict-type-table .el-table__row.current-row {
  background: #e6f7ff !important;
}
.dict-type-table .el-table__header th,
.dict-data-table .el-table__header th {
  background: #fafbfc;
  color: #666;
  font-weight: 500;
  font-size: 14px;
}
.dict-type-table .el-table__body td,
.dict-data-table .el-table__body td {
  font-size: 13px;
}
.dialog-form {
  padding: 12px 0 0 0;
}
</style> 